module.exports = __webpack_public_path__ + "static/media/rank-btn@2x.fbbb9376.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/rank-btn@2x.png
// module id = 894
// module chunks = 0